import axios from 'axios';
import * as types from './Template.types';
//import * as selectors from './Template.selectors';
import { showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as loginSelectors from './../Login/Login.selectors';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchDepartments = (id, subcategory = 0) => (dispatch, getState) => {
    const platformType = loginSelectors.getPlatformType(getState());

    dispatch({ type: types.FETCH_DEPARTMENTS, payload: null });
    axios.get(apiUrl + '/uthealth-departments?id=' + id + '&subcategory=' + subcategory + '&platform-type=' + platformType,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_DEPARTMENTS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_DEPARTMENTS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}
